import { Button, Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ref, remove } from "firebase/database";
import { logout, database } from "../firebase";
import { useSnack } from "../contexts/AlertContext";
import { useUser } from "../contexts/UserContext";

const AccountSettings = () => {
  const navigate = useNavigate();
  const setSnack = useSnack();
  const user = useUser();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const handleDeleteGames = async () => {
    const dbRef = ref(database, `id/${user.uid}`);
    try {
      await remove(dbRef);
      navigate("/record");
      setSnack({
        open: true,
        type: "success",
        message: "Successfully deleted all games."
      });
    } catch (e) {
      setSnack({
        open: true,
        type: "error",
        message:
          "An error occured deleting your games. Please refresh the page and try again."
      });
    }
  };

  return (
    <div>
      <Card sx={{ maxWidth: 600, mx: "auto", mb: 4 }}>
        <CardContent>
          <Typography variant="h6">Current Account: {user?.email}</Typography>
          <Button
            sx={{ marginTop: 2 }}
            fullWidth
            variant="contained"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </CardContent>
      </Card>

      <Card sx={{ maxWidth: 600, mx: "auto", my: 4 }}>
        <CardContent>
          <Typography variant="h6">Delete All Match Results</Typography>
          <Button
            sx={{ marginTop: 2 }}
            fullWidth
            variant="contained"
            color="error"
            onClick={handleDeleteGames}
          >
            Banish Match Results
          </Button>
          <Typography variant="caption">
            Be careful when you press this. You will not recieve shadows for
            deleted games.
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccountSettings;
